import ImportBotModal from './ImportBotModal'

export default ImportBotModal
